import React from 'react';

const paths = {
  microscope: (
    <>
      <path d="M4 21h16" />
      <path d="M7 21v-2.5a2 2 0 0 1 2-2h1.5" />
      <path d="M15 21v-2.5a2 2 0 0 0-2-2h-1.5" />
      <path d="M12 16.5V13" />
      <path d="M8.7 13h6.6l-1.3-3.2a3.3 3.3 0 0 0-6 0z" />
      <rect x="6" y="10.6" width="12" height="2.4" rx="0.5" />
      <path d="M12 9.8V4" />
      <path d="M9.8 4h4.4" />
    </>
  ),
  slide: (
    <>
      <rect x="4" y="7" width="16" height="10" rx="1.5" />
      <circle cx="9" cy="12" r="1.1" />
      <circle cx="13" cy="12" r="1.1" />
      <circle cx="17" cy="12" r="1.1" />
    </>
  ),
  droplet: <path d="M12 3c4 5 6 8.5 6 11a6 6 0 1 1-12 0c0-2.5 2-6 6-11Z" />,
  layers: (
    <>
      <path d="M12 3 3 8l9 5 9-5-9-5Z" />
      <path d="M3 12l9 5 9-5" />
      <path d="M3 16l9 5 9-5" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4.2" />
      <circle cx="12" cy="12" r="0.6" fill="currentColor" stroke="none" />
    </>
  ),
  dna: (
    <>
      <path d="M7 3c0 4 10 4 10 8s-10 4-10 8" />
      <path d="M17 3c0 4-10 4-10 8s10 4 10 8" />
      <path d="M8 7h8" />
      <path d="M8 17h8" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
      <circle cx="17" cy="9" r="2.3" />
      <path d="M15.2 13.2c2.3.3 4 2 4.3 4.4" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 4.5 6v6c0 5 3.5 7.6 7.5 9 4-1.4 7.5-4 7.5-9V6L12 3Z" />
      <path d="M8.7 12.2l2.3 2.3 4.3-4.7" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7v5l3.3 2" />
    </>
  ),
  truck: (
    <>
      <rect x="2.5" y="8" width="11" height="8" rx="1" />
      <path d="M13.5 11h3.5l3 3v2h-6.5" />
      <circle cx="7" cy="18" r="1.7" />
      <circle cx="16.5" cy="18" r="1.7" />
    </>
  ),
  fileCheck: (
    <>
      <path d="M8 3h6l4 4v12a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
      <path d="M14 3v4h4" />
      <path d="M9.5 13.5l2 2 4-4.5" />
    </>
  ),
  flag: (
    <>
      <path d="M6 3v18" />
      <path d="M6 4.5c2-1 4-1 6 0s4 1 6 0v8c-2 1-4 1-6 0s-4-1-6 0V4.5Z" />
    </>
  ),
  phone: <path d="M6 3.5h3l1.3 4-2 1.6a11 11 0 0 0 5.6 5.6l1.6-2 4 1.3v3a1.5 1.5 0 0 1-1.6 1.5A15.5 15.5 0 0 1 4.5 5.1 1.5 1.5 0 0 1 6 3.5Z" />
};

function Icon({ name, className }) {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {content}
    </svg>
  );
}

export default Icon;
